module.exports = __webpack_public_path__ + "img/logo.1631c2a9.svg";